import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';
import { WorkflowsComponent } from '../../../views/site/workflows/workflows.component';
import {
    OpenWorkflowItemContextMenuData,
    DeleteWorkflowItemContextMenuData
} from './item-menu-classes';

export class WorkflowsItemContextMenuData {
    // Properties.
    private itemContextMenuData: IContextMenuItem[];

    public get ItemContextMenuData(): IContextMenuItem[] {
        return this.itemContextMenuData;
    }

    // Constructor.
    public constructor(private workflowsComponent: WorkflowsComponent) {
        this.itemContextMenuData = [
            new OpenWorkflowItemContextMenuData('Open', this.workflowsComponent),
            new DeleteWorkflowItemContextMenuData('Delete ...', this.workflowsComponent),
        ];
    }
}
